import axios from "axios";
import { config } from "../../Utils/helpers";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const listReferralCommission = (requestData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_REFERRAL_COMMISSION_LIST_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/referral-commission/list`,
        requestData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_REFERRAL_COMMISSION_LIST_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_REFERRAL_COMMISSION_LIST_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_REFERRAL_COMMISSION_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Failed to fetch referral commissions");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const addReferralCommission = (payload) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_REFERRAL_COMMISSION_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/referral-commission/add`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_REFERRAL_COMMISSION_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "ADD_REFERRAL_COMMISSION_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "ADD_REFERRAL_COMMISSION_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Failed to add referral commission");
      throw error;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const viewReferralCommission = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_REFERRAL_COMMISSION_REQUEST" });

      const { data } = await axios.get(
        `${BASE_URL}/referral-commission/view/${id}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_REFERRAL_COMMISSION_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_REFERRAL_COMMISSION_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_REFERRAL_COMMISSION_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Failed to fetch referral commission");
      throw error;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const updateStatusReferralCommission = (id, status) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_REFERRAL_COMMISSION_STATUS_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/referral-commission/update`,
        { id, status }, // the payload structure as in your component
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_REFERRAL_COMMISSION_STATUS_SUCCESS", payload: data });
        toast.success("Status updated successfully!");
        return data;
      } else {
        dispatch({ type: "UPDATE_REFERRAL_COMMISSION_STATUS_FAILED", payload: data });
        toast.error(data?.message || "Failed to update status");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_REFERRAL_COMMISSION_STATUS_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Failed to update status");
      throw error;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const updateReferralCommission = (payload) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_REFERRAL_COMMISSION_REQUEST" });

      const { id, ...updateFields } = payload;

      const { data } = await axios.post(
        `${BASE_URL}/referral-commission/update/${id}`, // id as URL param
        updateFields, // rest of fields in body
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_REFERRAL_COMMISSION_SUCCESS", payload: data });
        toast.success("Referral commission updated successfully!");
        return data;
      } else {
        dispatch({ type: "UPDATE_REFERRAL_COMMISSION_FAILED", payload: data });
        toast.error(data?.message || "Failed to update referral commission");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_REFERRAL_COMMISSION_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Failed to update referral commission");
      throw error;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
